<script>
import Layout from "@/router/layouts/main";
import { api } from "@/state/services";

export default {
  components: { Layout },
  data() {
    return {
      loading: false,
      legal: null,
      form: {
        company_name: "",
        cnpj: "",
        opening: "",
        doc_type: "contract",
      },
      file: null,
    };
  },
  methods: {
    load() {
      api.get("user/legal-person").then((res) => {
        if (res.data.status === "success") {
          this.legal = res.data.legal;
        }
      });
    },
    onFile(e) {
      const f = e.target.files && e.target.files[0];
      this.file = f || null;
    },
    submit() {
      if (!this.file) {
        this.$toast.error("Selecione o arquivo do documento.");
        return;
      }
      this.loading = true;
      const fd = new FormData();
      fd.append("company_name", this.form.company_name);
      fd.append("cnpj", this.form.cnpj);
      fd.append("opening", this.form.opening);
      fd.append("doc_type", this.form.doc_type);
      fd.append("file", this.file);
      api
        .post("user/legal-person", fd)
        .then((res) => {
          if (res.data.status === "success") {
            this.$toast.success(res.data.message || "Pedido enviado.");
            this.load();
            this.file = null;
            this.form = {
              company_name: "",
              cnpj: "",
              opening: "",
              doc_type: "contract",
            };
          } else {
            this.$toast.error(res.data.message || "Não foi possível enviar.");
          }
        })
        .catch(() => {
          this.$toast.error("Não foi possível enviar. Tente novamente.");
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  mounted() {
    this.load();
  },
};
</script>

<template>
  <Layout>
    <ol class="breadcrumb">
      <li class="breadcrumb-item">
        <router-link tag="a" to="/">Início</router-link>
      </li>
      <li class="breadcrumb-item d-none d-sm-block">Migrar para PJ</li>
    </ol>

    <div class="page-title-box d-md-flex justify-content-between">
      <div>
        <h3>Migrar para pessoa jurídica</h3>
        <p class="text-muted mb-0">
          Envie contrato social, requerimento de empresário ou certificado MEI.
        </p>
      </div>
    </div>

    <div class="card" v-if="legal">
      <div class="card-body">
        <div v-if="legal.person_type === 'legal'" class="alert alert-success mb-0">
          Sua conta já está cadastrada como pessoa jurídica.
        </div>
        <div v-else-if="legal.request_status === 'pending'" class="alert alert-warning mb-0">
          Seu pedido está em análise, aguarde a aprovação.
        </div>
        <div v-else-if="legal.request_status === 'rejected'" class="alert alert-danger">
          <strong>Pedido reprovado.</strong>
          {{ legal.rejected_reason || "" }}
          <p class="mb-0 mt-2">Você pode enviar um novo pedido abaixo.</p>
        </div>
        <template v-else>
          <p class="text-muted small">
            Os dados do sócio serão preservados a partir do seu cadastro atual (nome e CPF), quando aplicável.
          </p>
          <b-form @submit.prevent="submit">
            <b-form-group label="Razão social" label-for="company_name">
              <b-form-input id="company_name" v-model="form.company_name" required />
            </b-form-group>
            <b-form-group label="CNPJ" label-for="cnpj">
              <b-form-input
                id="cnpj"
                v-model="form.cnpj"
                type="text"
                inputmode="numeric"
                v-mask="'##.###.###/####-##'"
                required
              />
            </b-form-group>
            <b-form-group label="Data de abertura" label-for="opening">
              <b-form-input id="opening" v-model="form.opening" type="date" required />
            </b-form-group>
            <b-form-group label="Documento" label-for="doc_type">
              <b-form-select id="doc_type" v-model="form.doc_type" :options="[
                { value: 'contract', text: 'Contrato social' },
                { value: 'entrepreneur', text: 'Requerimento de empresário' },
                { value: 'mei', text: 'Certificado MEI (CCMEI)' },
              ]" />
            </b-form-group>
            <b-form-group label="Arquivo (PDF ou imagem)" label-for="file">
              <b-form-file id="file" accept=".pdf,.jpg,.jpeg,.png,.webp" @change="onFile" />
            </b-form-group>
            <b-button type="submit" variant="default" :disabled="loading" size="lg">
              Enviar pedido
            </b-button>
          </b-form>
        </template>
      </div>
    </div>
  </Layout>
</template>
